import React from 'react'
import { Link } from 'react-router-dom'
import ClientshotLogoWhite from '../assets/svgs/logo/Clientshot_logo_white.svg'
import Facebook from '../assets/svgs/socials/facebook.svg'
import Instagram from '../assets/svgs/socials/instagram.svg'
import Twitter from '../assets/svgs/socials/twitter.svg'
import Linkedin from '../assets/svgs/socials/linkedin.svg'
import Youtube from '../assets/svgs/socials/youtube.svg'
import Whatsapp from '../assets/svgs/whatsapp.svg'

const Footer = () => {
    return (
        <>
            <div className='bg-black pl-6 md:pl-20 pt-20 pr-6 md:pr-20 pb-5'>
                <div className='container mx-auto'>
                    <div className="mb-4">
                        <Link to={`/`} >
                            <img src={ClientshotLogoWhite} alt="" style={{ height: 50 }} />
                        </Link>
                    </div>

                    <div className="md:flex justify-between gap-x-4 md:w-full">
                        <div className='mb-16 md:w-1/4'>
                            <p className='text-white base-text '>
                                Clientshot is a product of SeamHealth Group, a leading provider of healthcare technology solutions <br /><br />
                                Clientshot is a customer satisfaction tool that helps businesses collect and analyze feedback from their customers. Our goal is...
                                <Link to={`/about`} className="ml-2 primary-500">Read more</Link>
                            </p>

                        </div>
                        <div className="flex gap-12 md:gap-24 flex-col md:flex-row ">
                            <div>
                                <h6 className='heading-six text-white'>Company</h6>
                                <div className="mt-6">
                                    <Link to={`/`} className='text-link block mb-6' style={{ color: 'white' }}>
                                        Home
                                    </Link>
                                    <Link to={`/about`} className='text-link block mb-6' style={{ color: 'white' }}>
                                        About
                                    </Link>
                                    <Link to={`/contact`} className='text-link block mb-6' style={{ color: 'white' }}>
                                        Contact
                                    </Link>
                                    <Link to={`/pricing`} className='text-link block mb-6' style={{ color: 'white' }}>
                                        Pricing
                                    </Link>
                                </div>
                            </div>

                            <div>
                                <h6 className='heading-six text-white'>Resources</h6>
                                <div className="mt-6">
                                    {/* <a href={"https://clientshot.com/blog"} className='text-link block mb-6 ' style={{ color: 'white' }}>
                                        Blog
                                    </a> */}
                                    <a href={"https://www.youtube.com/@Clientshot"} target={'_blank'} rel="noreferrer" className='text-link block mb-6 ' style={{ color: 'white' }}>
                                        Tutorials
                                    </a>

                                </div>
                            </div>

                            <div>
                                <h6 className='heading-six text-white'>Follow us</h6>
                                <div className="mt-6 flex gap-x-6">
                                    <a href={`https://www.facebook.com/clientshot1`} target={'_blank'} rel="noreferrer" className='text-link social-icon block mb-6' style={{ color: 'white' }}>
                                        <img src={Facebook} alt="facebook" />
                                    </a>
                                    <a href={`https://instagram.com/client_shot`} target={'_blank'} rel="noreferrer" className='text-link social-icon block mb-6' style={{ color: 'white' }}>
                                        <img src={Instagram} alt="instagram" />
                                    </a>
                                    <a href={`https://twitter.com/clientshot`} target={'_blank'} rel="noreferrer" className='text-link social-icon block mb-6' style={{ color: 'white' }}>
                                        <img src={Twitter} alt="twitter" />
                                    </a>
                                    <a href={`https://www.linkedin.com/company/clientshot/`} target={'_blank'} rel="noreferrer" className='text-link social-icon block mb-6' style={{ color: 'white' }}>
                                        <img src={Linkedin} alt="linkedin" />
                                    </a>
                                    <a href={`https://www.youtube.com/@Clientshot`} target={'_blank'} rel="noreferrer" className='text-link social-icon block mb-6' style={{ color: 'white' }}>
                                        <img src={Youtube} alt="youtube" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <a href="https://wa.me/2347077964074" className='whatsapp-button' target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className='whatsapp-icon' viewBox="0 0 16 16" id="whatsapp">
  <path d="M8.002 0h-.004C3.587 0 0 3.588 0 8a7.94 7.94 0 0 0 1.523 4.689l-.997 2.972 3.075-.983A7.93 7.93 0 0 0 8.002 16C12.413 16 16 12.411 16 8s-3.587-8-7.998-8zm4.655 11.297c-.193.545-.959.997-1.57 1.129-.418.089-.964.16-2.802-.602-2.351-.974-3.865-3.363-3.983-3.518-.113-.155-.95-1.265-.95-2.413s.583-1.707.818-1.947c.193-.197.512-.287.818-.287.099 0 .188.005.268.009.235.01.353.024.508.395.193.465.663 1.613.719 1.731.057.118.114.278.034.433-.075.16-.141.231-.259.367-.118.136-.23.24-.348.386-.108.127-.23.263-.094.498.136.23.606.997 1.298 1.613.893.795 1.617 1.049 1.876 1.157.193.08.423.061.564-.089.179-.193.4-.513.625-.828.16-.226.362-.254.574-.174.216.075 1.359.64 1.594.757.235.118.39.174.447.273.056.099.056.564-.137 1.11z"></path>
</svg>
                    {/* <img src={Whatsapp} className='whatsapp' alt="" /> */}
                        Send a message
                        </a>

                    <footer className='text-white md:flex justify-between mt-20'>
                        <p className='small-text text-white text-center md:text-left'>
                            &copy; Copyright 2023 Clientshot <br className='md:hidden mb-8' /> | A product of <a href={"https://seamhealth.com"} target={'_blank'} rel="noreferrer" className='primary-500'>SeamHealth Group</a>
                        </p>

                        <div className="flex gap-x-8 items-center justify-center mt-8 md:mt-0">
                            <a href={"https://app.clientshot.com/terms-and-conditons"} target={'_blank'} rel="noreferrer" className='text-link small-text ' style={{ color: 'white' }}>
                                Terms of Service
                            </a>

                            <a href={"https://app.clientshot.com/privacy-policy"} target={'_blank'} rel="noreferrer" className='text-link small-text ' style={{ color: 'white' }}>
                                Privacy Policy
                            </a>

                            <a href="/sitemap.xml" className='text-link small-text ' style={{ color: 'white' }}>
                                Sitemap
                            </a>
                        </div>
                    </footer>
                </div>
            </div>
        </>
    )
}

export default Footer